export const videos = [{
        id: 1,
        year: 2020,
        videoId: "20e9c0e0-f6ca-4bcf-8d18-0497382e2e39",
        title: "How To Successfully Pitch Yourself In Academia",
        topic: "Academia",
        thumbnailPath: "20e9c0e0-f6ca-4bcf-8d18-0497382e2e39.jpg",
        duration: 3010,
    },
    {
        id: 2,
        year: 2020,
        videoId: "7bb657c6-befd-42e9-b964-f1645608434e",
        title: "Education and Accessibility in the SynBio Ecosystem",
        topic: "Accessibility",
        thumbnailPath: "7bb657c6-befd-42e9-b964-f1645608434e.jpg",
        duration: 2658,
    },
    {
        id: 3,
        year: 2020,
        videoId: "3e78383b-f1b8-49bd-9bff-8deab07a9bb3",
        title: "Frugal/Low-Cost Science",
        topic: "Accessibility",
        thumbnailPath: "3e78383b-f1b8-49bd-9bff-8deab07a9bb3.jpg",
        duration: 3087,
    },
    {
        id: 4,
        year: 2020,
        videoId: "4f6903f1-1cc3-4ef3-981e-dced72fa7727",
        title: "The future of biological parts screening",
        topic: "Biosafety",
        thumbnailPath: "4f6903f1-1cc3-4ef3-981e-dced72fa7727.jpg",
        duration: 2822,
    },
    {
        id: 5,
        year: 2020,
        videoId: "7fa2771a-f45d-4934-bb7a-d070f4f5cad4",
        title: "Maximizing Benefits, Minimizing Risks",
        topic: "Biosafety",
        thumbnailPath: "7fa2771a-f45d-4934-bb7a-d070f4f5cad4.jpg",
        duration: 2518,
    },
    {
        id: 6,
        year: 2020,
        videoId: "419cdff2-c921-44ca-98f4-c4b489979048",
        title: "Science Communication Careers: An Exploratory Journey",
        topic: "Communication",
        thumbnailPath: "419cdff2-c921-44ca-98f4-c4b489979048.jpg",
        duration: 5169,
    },
    {
        id: 7,
        year: 2020,
        videoId: "d8bce530-572d-48c0-9c3e-bee32bbc41aa",
        title: "Creative Storytelling in Synthetic Biology - with Ginkgo Bioworks' Grace Chuang",
        topic: "Communication",
        thumbnailPath: "d8bce530-572d-48c0-9c3e-bee32bbc41aa.jpg",
        duration: 3084,
    },
    {
        id: 8,
        year: 2020,
        videoId: "14d981ff-4e6e-4ac9-a67f-30c8137b8a6f",
        title: "Communicating Science to Non-Experts",
        topic: "Communication",
        thumbnailPath: "14d981ff-4e6e-4ac9-a67f-30c8137b8a6f.jpg",
        duration: 2549,
    },
    {
        id: 9,
        year: 2020,
        videoId: "dbcfe1fd-50fd-463b-a3ee-50ef76592a4f",
        title: "Beyond an iGEM team: how to stay connected with other local iGEMers after the competition",
        topic: "Community",
        thumbnailPath: "dbcfe1fd-50fd-463b-a3ee-50ef76592a4f.jpg",
        duration: 2316,
    },
    {
        id: 10,
        year: 2020,
        videoId: "6b3b29a2-a001-4f43-961e-b6e89a653a86",
        title: "Capturing stories of iGEMers: The After iGEM Experience",
        topic: "Community",
        thumbnailPath: "6b3b29a2-a001-4f43-961e-b6e89a653a86.jpg",
        duration: 3814,
    },
    {
        id: 11,
        year: 2020,
        videoId: "a0f994e1-54b1-416c-a36b-7bdb30ba672f",
        title: "Industry or Academia: Inspiration to decide",
        topic: "Community",
        thumbnailPath: "a0f994e1-54b1-416c-a36b-7bdb30ba672f.jpg",
        duration: 2544,
    },
    {
        id: 12,
        year: 2020,
        videoId: "c61b0ba7-27f6-4bfc-ab8f-0c7f77167aab",
        title: "JOGL: Collaborative Science in the 21st Century",
        topic: "Community",
        thumbnailPath: "c61b0ba7-27f6-4bfc-ab8f-0c7f77167aab.jpg",
        duration: 2632,
    },
    {
        id: 13,
        year: 2020,
        videoId: "bc11a353-7023-4607-b9e8-a3928ae3539b",
        title: "Guidelines to building and managing a SynBio Association",
        topic: "Community",
        thumbnailPath: "bc11a353-7023-4607-b9e8-a3928ae3539b.jpg",
        duration: 1781,
    },
    {
        id: 14,
        year: 2020,
        videoId: "ff761edc-b704-49ee-8136-ac779f8d7a38",
        title: "CCiC: from Meet Up to Community",
        topic: "Community",
        thumbnailPath: "ff761edc-b704-49ee-8136-ac779f8d7a38.jpg",
        duration: 1380,
    },
    {
        id: 15,
        year: 2020,
        videoId: "effe07cb-9cba-4996-96b0-dc162675e8ef",
        title: "Welcome Ceremony (Around The World Tour)",
        topic: "Community",
        thumbnailPath: "effe07cb-9cba-4996-96b0-dc162675e8ef.jpg",
        duration: 2591,
    },
    {
        id: 16,
        year: 2020,
        videoId: "ec3fd9f4-4723-42c1-8e63-cf0a46580f45",
        title: "Optimizing Team Structure for SynBio Projects",
        topic: "Community",
        thumbnailPath: "ec3fd9f4-4723-42c1-8e63-cf0a46580f45.jpg",
        duration: 2790,
    },
    {
        id: 17,
        year: 2020,
        videoId: "2f45501d-a4dd-4c70-9efd-737b4e7eb45b",
        title: "University BioMakerspaces: An Emerging Network",
        topic: "Community",
        thumbnailPath: "2f45501d-a4dd-4c70-9efd-737b4e7eb45b.jpg",
        duration: 3528,
    },
    {
        id: 18,
        year: 2020,
        videoId: "7e416331-b6d4-4bff-977b-2d6b27a6dd7d",
        title: "Women in iGEM and STEM",
        topic: "Diversity",
        thumbnailPath: "7e416331-b6d4-4bff-977b-2d6b27a6dd7d.jpg",
        duration: 2431,
    },
    {
        id: 19,
        year: 2020,
        videoId: "31050c8e-d378-434f-968f-e865b0586bac",
        title: "Women in STEM: Panel Discussion",
        topic: "Diversity",
        thumbnailPath: "31050c8e-d378-434f-968f-e865b0586bac.jpg",
        duration: 3652,
    },
    {
        id: 20,
        year: 2020,
        videoId: "b68478b9-c70d-4cb3-a29c-0bf1fb78408d",
        title: "Planning and Designing Your Project",
        topic: "Engineering",
        thumbnailPath: "b68478b9-c70d-4cb3-a29c-0bf1fb78408d.jpg",
        duration: 2981,
    },
    {
        id: 21,
        year: 2020,
        videoId: "62e581f5-84c8-47da-b9f2-9d33aa216d14",
        title: "Cloning and Assembly Plans",
        topic: "Engineering",
        thumbnailPath: "62e581f5-84c8-47da-b9f2-9d33aa216d14.jpg",
        duration: 2697,
    },
    {
        id: 22,
        year: 2020,
        videoId: "ff382d4e-9a15-4f57-96f7-76fab369a8d6",
        title: "Engineering Biological Information Processing Systems",
        topic: "Engineering",
        thumbnailPath: "ff382d4e-9a15-4f57-96f7-76fab369a8d6.jpg",
        duration: 2878,
    },
    {
        id: 23,
        year: 2020,
        videoId: "fce150c3-8b09-4d6b-89dd-d53f2b3367be",
        title: "2020 Intro: Summer Webinars from the Measurement Committee",
        topic: "Engineering",
        thumbnailPath: "4a8f0a7e-2eff-4ee5-9881-c0d786638d81.jpg",
        duration: 1270,
    },
    {
        id: 24,
        year: 2020,
        videoId: "0ed209c7-c434-4e7d-b5c2-e20c22d3be04",
        title: "Bioinspired Valuation Models",
        topic: "Entrepreneurship",
        thumbnailPath: "0ed209c7-c434-4e7d-b5c2-e20c22d3be04.jpg",
        duration: 3509,
    },
    {
        id: 25,
        year: 2020,
        videoId: "270fcd31-10b4-4658-baad-d6f4bf3f49a7",
        title: "iGEM Startup Stories",
        topic: "Entrepreneurship",
        thumbnailPath: "270fcd31-10b4-4658-baad-d6f4bf3f49a7.jpg",
        duration: 3045,
    },
    {
        id: 26,
        year: 2020,
        videoId: "e6513483-fb66-46dd-91c9-567f05a14fe1",
        title: "Intro to iGEM EPIC: Entrepreneurial Program & Innovation Community",
        topic: "Entrepreneurship",
        thumbnailPath: "e6513483-fb66-46dd-91c9-567f05a14fe1.jpg",
        duration: 264,
    },
    {
        id: 27,
        year: 2020,
        videoId: "3dfebd86-0883-4000-97b1-587c665c9373",
        title: "Good ideas needs good policy!",
        topic: "Governance",
        thumbnailPath: "3dfebd86-0883-4000-97b1-587c665c9373.jpg",
        duration: 3792,
    },
    {
        id: 28,
        year: 2020,
        videoId: "136b169a-6425-4e10-9ba3-b25a4f7a83e7",
        title: "GMOs in Agriculture - The Nobel Laureates’ Campaign",
        topic: "Governance",
        thumbnailPath: "136b169a-6425-4e10-9ba3-b25a4f7a83e7.jpg",
        duration: 4337,
    },
    {
        id: 29,
        year: 2020,
        videoId: "ee53a46f-a18d-47af-8870-66edcb461ecf",
        title: "Human Practices Spotlight: Megan Palmer and Ruipeng Lei in Conversation",
        topic: "Human Practices",
        thumbnailPath: "ee53a46f-a18d-47af-8870-66edcb461ecf.jpg",
        duration: 2241,
    },
    {
        id: 30,
        year: 2020,
        videoId: "7920dd3d-8e4d-4667-9315-32f7f2d221e1",
        title: "How to Present your Project by Story-Telling?",
        topic: "Human Practices",
        thumbnailPath: "7920dd3d-8e4d-4667-9315-32f7f2d221e1.jpg",
        duration: 2152,
    },
    {
        id: 31,
        year: 2020,
        videoId: "df680270-67dc-4d05-978e-f49276601553",
        title: "How to Find Insights from Social Science Research Related to Your Project",
        topic: "Human Practices",
        thumbnailPath: "df680270-67dc-4d05-978e-f49276601553.jpg",
        duration: 2385,
    },
    {
        id: 32,
        year: 2020,
        videoId: "718c80d4-b4fa-4d1e-a646-ea9ce6683305",
        title: "Designing Scientifically Valid Surveys",
        topic: "Human Practices",
        thumbnailPath: "718c80d4-b4fa-4d1e-a646-ea9ce6683305.jpg",
        duration: 2652,
    },
    {
        id: 33,
        year: 2020,
        videoId: "ae06d1c3-9395-47c3-b3d8-ba47fb1ce777",
        title: "Doing Human Practices during a Global Pandemic",
        topic: "Human Practices",
        thumbnailPath: "ae06d1c3-9395-47c3-b3d8-ba47fb1ce777.jpg",
        duration: 2462,
    },
    {
        id: 34,
        year: 2020,
        videoId: "11f57fb6-6ac7-4312-8d63-f5f94b990b2f",
        title: "High School iGEM: Reflections and Future",
        topic: "iGEM",
        thumbnailPath: "11f57fb6-6ac7-4312-8d63-f5f94b990b2f.jpg",
        duration: 2599,
    },
    {
        id: 35,
        year: 2020,
        videoId: "df35f32a-4154-4a69-b16f-2bda488e84a8",
        title: "iGEM Insights: Understanding iGEM Through Data",
        topic: "iGEM",
        thumbnailPath: "df35f32a-4154-4a69-b16f-2bda488e84a8.jpg",
        duration: 1674,
    },
    {
        id: 36,
        year: 2020,
        videoId: "b0fe6b47-de5a-4e9b-913e-8f1840c1b0f1",
        title: "2020 iGEM President's Message: Randy Rettberg",
        topic: "iGEM",
        thumbnailPath: "b0fe6b47-de5a-4e9b-913e-8f1840c1b0f1.jpg",
        duration: 675,
    },
    {
        id: 37,
        year: 2020,
        videoId: "1fb71503-b861-4113-95c4-8a547720ac26",
        title: "2020 iGEM Finalists Interviews",
        topic: "iGEM",
        thumbnailPath: "1fb71503-b861-4113-95c4-8a547720ac26.jpg",
        duration: 499,
    },
    {
        id: 38,
        year: 2020,
        videoId: "b1a6d7ce-5c51-42ec-b324-6bf693a07951",
        title: "After iGEM: What happens beyond the competition?",
        topic: "iGEM",
        thumbnailPath: "b1a6d7ce-5c51-42ec-b324-6bf693a07951.jpg",
        duration: 460,
    },
    {
        id: 39,
        year: 2020,
        videoId: "b0bd9c93-c03d-45d5-9d13-c077362f7150",
        title: "Same but different: a global perspective in the synbio industry",
        topic: "Industry",
        thumbnailPath: "b0bd9c93-c03d-45d5-9d13-c077362f7150.jpg",
        duration: 2974,
    },
    {
        id: 40,
        year: 2020,
        videoId: "53107623-f2b8-4205-ad4c-bcb0c9b84864",
        title: "Celebrating and Discussing Mentorship in iGEM",
        topic: "Mentorship",
        thumbnailPath: "53107623-f2b8-4205-ad4c-bcb0c9b84864.jpg",
        duration: 2144,
    },
    {
        id: 41,
        year: 2020,
        videoId: "c6a98e01-ec9f-4174-bf48-60d925a9e3d5",
        title: "Navigating iGEM and beyond: The Mentorship Network and Eduhall",
        topic: "Mentorship",
        thumbnailPath: "c6a98e01-ec9f-4174-bf48-60d925a9e3d5.jpg",
        duration: 1690,
    },
    {
        id: 42,
        year: 2020,
        videoId: "8d3da290-72d1-45c3-a77d-195000944e4c",
        title: "How to Build your Team Wiki?",
        topic: "Software",
        thumbnailPath: "8d3da290-72d1-45c3-a77d-195000944e4c.jpg",
        duration: 2590,
    },
    {
        id: 43,
        year: 2020,
        videoId: "51dd8c47-f16e-4b57-b39f-a029141bce80",
        title: "Software Tools for Genetic Design",
        topic: "Software",
        thumbnailPath: "51dd8c47-f16e-4b57-b39f-a029141bce80.jpg",
        duration: 3277,
    },
    {
        id: 44,
        year: 2020,
        videoId: "1350d5be-1d39-4bf9-a30a-23884c1efaf2",
        title: "Modeling for Synthetic Biology",
        topic: "Software",
        thumbnailPath: "1350d5be-1d39-4bf9-a30a-23884c1efaf2.jpg",
        duration: 3127,
    },
    {
        id: 45,
        year: 2020,
        videoId: "5824a644-ef7c-45b0-bb0f-c7a3e37db061",
        title: "SynBio & Next 10 Years: Panel",
        topic: "SynBio",
        thumbnailPath: "5824a644-ef7c-45b0-bb0f-c7a3e37db061.jpg",
        duration: 3421,
    },
    {
        id: 46,
        year: 2020,
        videoId: "1ea2270a-b400-4942-b703-e72851049cec",
        title: "Care How Biology is Used - with Ginkgo Bioworks` Reshma Shetty",
        topic: "SynBio",
        thumbnailPath: "1ea2270a-b400-4942-b703-e72851049cec.jpg",
        duration: 2983,
    },
    {
        id: 47,
        year: 2020,
        videoId: "76fc7cb5-2590-4dc5-8655-10c8684eef38",
        title: "The birth of Synthetic Biology & iGEM - with Drew Endy (iGEMers of the World Podcast)",
        topic: "SynBio",
        thumbnailPath: "76fc7cb5-2590-4dc5-8655-10c8684eef38.jpg",
        duration: 3065,
    },
    {
        id: 48,
        year: 2020,
        videoId: "a80b22ce-e7b0-47a1-93b4-ae8a70b32607",
        title: "It’s time to Decode the World! - with Arvind Gupta and Po Branson (iGEMers of the World Podcast)",
        topic: "SynBio",
        thumbnailPath: "a80b22ce-e7b0-47a1-93b4-ae8a70b32607.jpg",
        duration: 2045,
    },
    {
        id: 49,
        year: 2020,
        videoId: "bd484a31-2763-4497-b9fb-008621d99d99",
        title: "A New Beginning In Ghana: Reflections from the journey and a roadmap for the local future of Synthetic Biology and iGEM",
        topic: "SynBio",
        thumbnailPath: "bd484a31-2763-4497-b9fb-008621d99d99.jpg",
        duration: 3620,
    },
    {
        id: 50,
        year: 2020,
        videoId: "9296cff2-f7e8-4df2-8117-8b9a826c5724",
        title: "Worldwide Synergy of Synthetic Biology",
        topic: "SynBio",
        thumbnailPath: "9296cff2-f7e8-4df2-8117-8b9a826c5724.jpg",
        duration: 2195,
    },
    {
        id: 51,
        year: 2020,
        videoId: "aa631779-da95-4140-9ab8-24c1be477df1",
        title: "Wiring the Past & Future: A Transition for Engineering Biology",
        topic: "SynBio",
        thumbnailPath: "aa631779-da95-4140-9ab8-24c1be477df1.jpg",
        duration: 4602,
    },
    {
        id: 52,
        year: 2020,
        videoId: "9d45bcdc-6ca3-4f12-81d6-8d25c9ff96bc",
        title: "Biotech Robotic Cloud Labs: During the Pandemic and Onwards",
        topic: "SynBio",
        thumbnailPath: "c75198cd-17ea-418b-83ac-4afc9a9e22e9.jpg",
        duration: 5265,
    },
    {
        id: 53,
        year: 2021,
        videoId: "67d3d88b-cb35-4f72-aaee-e2db6867ae75",
        title: "Introduction to Human Practices",
        topic: "Human Practices",
        thumbnailPath: "fc45d077-cffa-4fc3-b468-f555a3f52ec6.jpg",
        duration: 411,
    },
    {
        id: 54,
        year: 2021,
        videoId: "029a599a-5b1b-4aba-8ae2-635fd645ad81",
        title: "Introduction to Safety & Security",
        topic: "Biosafety",
        thumbnailPath: "ef3bfe09-4dcc-4a68-8693-5d1cde3b29ba.jpg",
        duration: 456,
    },
    {
        id: 55,
        year: 2021,
        videoId: "55d4c429-220d-4f4e-9482-828d381c8a9d",
        title: "HP Methods for Business/Entrepreneurship",
        topic: "Human Practices",
        thumbnailPath: "77ebbcb4-563b-4da0-9491-dcd25d9793d4.jpg",
        duration: 759,
    },
    {
        id: 56,
        year: 2021,
        videoId: "756a3daf-9816-4b9e-9ac9-a03361d0e652",
        title: "Empowering Local Networks",
        topic: "Community",
        thumbnailPath: "41a6df87-46ce-4872-bdfa-489e87bdefac.jpg",
        duration: 667,
    },
    {
        id: 57,
        year: 2021,
        videoId: "9d48d1fa-1f69-4a60-a843-4488bca9b90f",
        title: "How to properly engage with stakeholders in Human practices?",
        topic: "Human Practices",
        thumbnailPath: "0193b1fc-788f-414e-864b-e948837adc21.jpg",
        duration: 545,
    },
    {
        id: 58,
        year: 2021,
        videoId: "d1b5ab37-4b61-4c0f-a5ae-3f1f2fffdee1",
        title: "Engineering a Common (Synbio) Language",
        topic: "Accessibility",
        thumbnailPath: "7bf8879f-c39e-43dc-9182-3b6b4ab40241.jpg",
        duration: 600,
    },
    {
        id: 74,
        year: 2021,
        videoId: "b1b04f11-041f-468f-9f8e-d15ebf4ce0ba",
        title: "Intro: Engineering Committee",
        topic: "Engineering",
        thumbnailPath: "e51fcabb-fa2b-47a2-b464-59ec99c916e3.jpg",
        duration: 491,
    },
    {
        id: 59,
        year: 2021,
        videoId: "dbb995d9-6a74-4be2-8bb5-a864b3e47fe7",
        title: "iGEM as a Fuel for Academia",
        topic: "Academia",
        thumbnailPath: "09a50cc9-cceb-403f-98c7-30807833b04a.jpg",
        duration: 579,
    },
    {
        id: 60,
        year: 2021,
        videoId: "a3f50264-96ac-4690-92ad-76b3442db97f",
        title: "Top 5 Ways to Engage in Science Communication",
        topic: "Communication",
        thumbnailPath: "c54062a7-8833-415e-9e7a-53e598c61e59.jpg",
        duration: 564,
    },
    {
        id: 61,
        year: 2021,
        videoId: "d932922c-0042-4a16-9603-4bd7005dea80",
        title: "The Expanding Future of Synthetic Biology Education",
        topic: "SynBio",
        thumbnailPath: "14760492-0979-41b6-9b69-d8417bff4f87.jpg",
        duration: 644,
    },
    {
        id: 62,
        year: 2021,
        videoId: "641fc6d5-5a92-4f2e-844e-2d3bdfca910a",
        title: "Intro: Engineering Committee's 2021 Summer Webinar Series",
        topic: "Engineering",
        thumbnailPath: "1c09476d-bb1f-43e5-818a-385fdbe4ad4e.jpg",
        duration: 341,
    },
    {
        id: 63,
        year: 2021,
        videoId: "32da044c-b54a-428a-8c94-2a7a69cd3332",
        title: "The Rise of SynBio, from a Single Strand of DNA to a World of Possibilities",
        topic: "Industry",
        thumbnailPath: "0cf6f43e-6b55-4049-80ec-66a7749fbc76.jpg",
        duration: 417,
    },
    {
        id: 64,
        year: 2021,
        videoId: "6cd5596e-1e1f-4d01-bf2a-697241db89b0",
        title: "The Room Where It Happens: Shape the Future of Global Policy!",
        topic: "Governance",
        thumbnailPath: "83c1b414-68b1-4d31-88c0-d611d74f5827.jpg",
        duration: 318,
    },
    {
        id: 65,
        year: 2021,
        videoId: "8e92b963-3dc2-4820-9c64-56daf1522642",
        title: "Bio Convergence Revolution",
        topic: "SynBio",
        thumbnailPath: "31bc26cd-6483-402c-964c-8ed673a5272a.jpg",
        duration: 979,
    },
    {
        id: 66,
        year: 2021,
        videoId: "7e2470cc-6bd5-4be5-8a5f-3a34db01c50a",
        title: "Accelerating your Career with the iGEM Mentors Network",
        topic: "Mentorship",
        thumbnailPath: "0c34e57b-246e-4857-9276-5a5a8c2873cf.jpg",
        duration: 587,
    },
    {
        id: 73,
        year: 2021,
        videoId: "e1e1e89c-317b-4c0c-9dfd-c15c6a7ebdc7",
        title: "SynBio Stack Exchange",
        topic: "Engineering",
        thumbnailPath: "052f7fbe-47f7-4ef9-a5d2-f57f5dde0faa.jpg",
        duration: 312,
    },
    {
        id: 67,
        year: 2021,
        videoId: "e39c3fcc-7e65-4227-a210-a8e1225e2872",
        title: "African iGEM Experience and How and Why to participate in iGEM",
        topic: "Community",
        thumbnailPath: "18b9a9af-efc9-4cef-8305-fdb0a85634ee.jpg",
        duration: 866,
    },
    {
        id: 68,
        year: 2021,
        videoId: "fc57a67a-d134-46df-96d3-9caa964dce58",
        title: "The Work in Progress Initiative",
        topic: "Community",
        thumbnailPath: "5779a737-cea0-471d-8899-724950ac77e9.jpg",
        duration: 312,
    },
    {
        id: 69,
        year: 2021,
        videoId: "28c5c1d7-c0ad-4fb5-b0a9-7e3ca7b609e5",
        title: "iGEM Reflections from Asia & Beyond",
        topic: "Community",
        thumbnailPath: "34c065b5-f727-4538-bfe6-1f250e7fa3f4.jpg",
        duration: 621,
    },
    {
        id: 70,
        year: 2021,
        videoId: "912c4735-e582-4d0b-b515-d274dd5fcd32",
        title: "North American iGEM Experience",
        topic: "Community",
        thumbnailPath: "8b34d746-eab5-4ad5-8a6c-a6760e0bf180.jpg",
        duration: 628,
    },
    {
        id: 71,
        year: 2021,
        videoId: "bebd64fd-9f63-46db-9b9e-bea6bbb8ecdf",
        title: "Latin American iGEM Experience",
        topic: "Community",
        thumbnailPath: "9dd58491-6590-4976-8b0f-a1e541fd0d98.jpg",
        duration: 497,
    },
    {
        id: 72,
        year: 2021,
        videoId: "fa62007e-1d48-47cb-bc1e-c51fcfdb6d82",
        title: "Intro: Diversity and Inclusion Committee",
        topic: "Diversity",
        thumbnailPath: "7c0283c9-85fc-4e09-a228-279f595c1a36.jpg",
        duration: 635,
    },
];
export const filters = [
    { name: "Academia", color: "#A5B4FC", type: 0 },
    { name: "Accessibility", color: "#F8ED6E", type: 0 },
    { name: "Biosafety", color: "#ED5757", type: 0 },
    { name: "Communication", color: "#F59B55", type: 0 },
    { name: "Community", color: "#F8ED6E", type: 0 },
    { name: "Diversity", color: "#D658BB", type: 0 },
    { name: "Engineering", color: "#40CC7F", type: 0 },
    { name: "Entrepreneurship", color: "#BF2359", type: 0 },
    { name: "Governance", color: "#ED5757", type: 0 },
    { name: "Human Practices", color: "#D658BB", type: 0 },
    { name: "iGEM", color: "#40CC7F", type: 0 },
    { name: "Industry", color: "#09C6C6", type: 0 },
    { name: "Mentorship", color: "#F59B55", type: 0 },
    { name: "Software", color: "#09C6C6", type: 0 },
    { name: "SynBio", color: "#40CC7F", type: 0 },
    { name: "Stories of iGEM", color: "#09c6c6", type: 1 },
    { name: "Your 2021 Journey", color: "#d658bb", type: 1 },
    { name: "Imagining the Future", color: "#40cc7f", type: 1 },
    { name: "Highlight", color: "#f8ed6e", type: 1 },
];